import { supabase } from '../supabaseClient';

export interface AppNotification {
  id: string;
  user_id: string;
  company_id: string;
  type:
    | 'shift_assigned'
    | 'shift_updated'
    | 'licence_submitted'
    | 'licence_reviewed'
    | 'report_assigned'
    | 'report_updated'
    | 'report_comment'
    | 'task_updated'
    | 'alarm_triggered';
  title: string;
  body: string;
  data: Record<string, unknown>;
  read_at: string | null;
  created_at: string;
}

export const notificationService = {
  async fetchNotifications(userId: string, limit = 50): Promise<AppNotification[]> {
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return (data ?? []) as AppNotification[];
  },

  async fetchUnreadCount(userId: string): Promise<number> {
    const { count, error } = await supabase
      .from('notifications')
      .select('id', { count: 'exact', head: true })
      .eq('user_id', userId)
      .is('read_at', null);

    if (error) throw error;
    return count ?? 0;
  },

  async markRead(ids: string[]): Promise<void> {
    const { error } = await supabase.rpc('mark_notifications_read', {
      p_notification_ids: ids,
    });
    if (error) throw error;
  },

  async markAllRead(): Promise<void> {
    const { error } = await supabase.rpc('mark_all_notifications_read');
    if (error) throw error;
  },

  subscribe(userId: string, callback: () => void): () => void {
    const channel = supabase
      .channel(`notifications_user_${userId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`,
        },
        callback,
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  },
};
